import { createContext, useState, useEffect, useCallback } from "react";
import { loginUser, logoutUser, refreshToken } from "../api/auth";
import { setUpInterceptors } from "../api/axios";

export const AuthContext = createContext();

const parseJWT = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch {
        return null;
    }
}

export const AuthProvider = ({ children }) => {

    const [auth, setAuth] = useState({
        access_token: localStorage.getItem("access_token"),
        refresh_token: localStorage.getItem("refresh_token"),
        user: parseJWT(localStorage.getItem("access_token"))
    });

    console.log(auth.user)

    const [ready, setReady] = useState(false);

    const login = async (username, password) => {
        
        try {
            const tokens = await loginUser(username, password);
            localStorage.setItem("access_token", tokens.access);
            localStorage.setItem("refresh_token", tokens.refresh);
            setAuth({
                access_token: tokens.access,
                refresh_token: tokens.refresh,
                user: parseJWT(tokens.access)
            });
        } catch (err) {
            if (err.response && err.response.data) {
                throw err;
            } else {
                throw new Error("Network / Server Error");
            }
        }
    }

    const logout = useCallback(async () => {

        if (localStorage.getItem("refresh_token")) {
            try {
                await logoutUser(localStorage.getItem("refresh_token"));
            } catch (err) {
                console.log(err)
            }                
        }

        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        setAuth({access_token: null, refresh_token: null, user: null});
    }, [])

    const tryTokenRefresh = useCallback(async () => {
        if (localStorage.getItem("refresh_token")) {
            try {
                const data = await refreshToken(localStorage.getItem("refresh_token"));
                localStorage.setItem("access_token", data.access);
                localStorage.setItem("refresh_token", data.refresh);
                setAuth({
                    access_token: data.access,
                    refresh_token: data.refresh,
                    user: parseJWT(data.access)
                });        
            } catch (err) {
                logout();
                throw err;
            }
        } else {
            logout();
            throw new Error("No Refresh Token Available")
        }
    }, [logout])

    useEffect(() => {
        const interval = setInterval(() => {
            tryTokenRefresh().catch(err => {
                console.log("Token refresh failed silently:", err);
            });
        }, 4.5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [tryTokenRefresh]);

    useEffect(() => {
        setUpInterceptors(auth, logout, tryTokenRefresh);
        setReady(true);
    }, [auth, tryTokenRefresh, logout])

    return (
        <AuthContext.Provider value={{ auth, login, logout, ready }}>
            {children}
        </AuthContext.Provider>
    )

}
